export const ROUTES = {
  CAB_SESSIONS: 'sessions',
  CAB_STATION: 'station',
  CAB_TRANSACTIONS: 'transactions',
  CAB_PROFILE: 'profile',
  CABINET: 'cabinet',
  CREATE_STATION: 'create-station',
  DASH_SESSIONS: 'sessions',
  DASH_SESSION_METRICS: 'sessions/:sessionId/metrics',
  DASH_STATIONS: 'stations',
  DASH_STATION_DETAILS: 'stations/:stationId',
  DASH_TRANSACTIONS: 'transactions',
  DASH_USERS: 'users',
  DASH_USER_DETAILS: 'users/:userId',
  DASH_ROLES: 'roles',
  DASH_ROLE_CREATE: 'roles/new',
  DASH_ROLE_EDIT: 'roles/:roleId',
  DASH_ORGANIZATIONS: 'organizations',
  DASH_ORGANIZATION_CREATE: 'organizations/new',
  DASH_ORGANIZATION_EDIT: 'organizations/:organizationId/edit',
  DASH_ORGANIZATION_STATIONS: 'organizations/:organizationId/stations',
  DASH_TEAM: 'team',
  DASH_PREMIUM: 'premium',
  DASH_ORGANIZATION_TEAM: 'organizations/:organizationId/team',
  DASH_ORGANIZATION_PREMIUM: 'organizations/:organizationId/premium',
  DASHBOARD: 'dashboard',
  LANDING: 'landing',
  LOGIN: 'login',
  LOGIN_OWNER: 'login-owner',
  ORGANISATION_LOGIN: 'organisation/login',
  LOYALTY: 'loyalty',
  MAP: 'map',
  METRICS: 'metrics',
  RESET_PASSWORD: 'reset-password',
  SERVICE_UNAVAILABLE: 'service-unavailable',
  STATIONS_LIST: 'stations-list',
  STATIONS_REQUEST: 'stations-request',
  TERMS_OF_USAGE: 'terms-of-usage',
  NOTIFICATIONS: 'notifications',
  DASH_STATION_REQUESTS: 'station-requests',
  DASH_SETTINGS: 'settings',
  DASH_SYSTEM: 'system',
  DASH_SUPPORT: 'support',
  DASH_SUPPORT_TICKET: 'support/:id',
  DASH_KNOWLEDGE_BASE: 'knowledge-base',
  DASH_PROFILE: 'profile',
};

export const organizationsListPath = () =>
  `/${ROUTES.DASHBOARD}/${ROUTES.DASH_ORGANIZATIONS}`;

export const organizationCreatePath = () =>
  `/${ROUTES.DASHBOARD}/${ROUTES.DASH_ORGANIZATION_CREATE}`;

export const organizationEditPath = (orgId: string) =>
  `/${ROUTES.DASHBOARD}/organizations/${orgId}/edit`;

export const organizationTeamPath = (orgId: string) =>
  `/${ROUTES.DASHBOARD}/organizations/${orgId}/team`;
